module.exports = {
  QS_PARAM_IDENTIFIER: 'ywswithlog',
  PROCESS_ENV_IDENTIFIER: 'YWSLOG',
  PROCESS_ENV_VALUE: process.env.YWSLOG,
}
